import { IEvent } from "~app/common/services/cqs/event.service";

export class ArbetsorderWorkEventMessage implements IEvent {
    $type: string;
    arbetsorderId: number;
    arbetsorderHandelssortimentId: number;
    destineringId: number;
    work: string;
    workRef: string;
    workDescription: string;
    status: string;
    messageTimestamp: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderWorkEventMessage";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static pending = "Pending";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static completed = "Completed";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static error = "Error";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static abort = "Abort";
}
